import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-secondary to-background overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        <div className="flex justify-center mb-8">
          <Image
            src="https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763809516/First_on_Date_Logo_paokx0.png"
            alt="Bee Wise company logo featuring yellow bee icon with modern typography representing employee onboarding platform"
            className="h-16 w-auto" />

        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-foreground mb-6 leading-tight">
          Transform Chaotic Onboarding
          <span className="block text-primary mt-2">Into Structured Success</span>
        </h1>

        <p className="text-xl md:text-2xl text-muted-foreground mb-12 max-w-3xl mx-auto leading-relaxed">
          Reduce new hire anxiety, save manager time, and accelerate productivity by 3x through AI-powered assistance and systematic knowledge delivery
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <Button
            variant="default"
            size="xl"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => navigate('/login-authentication')}
            className="min-w-[200px]">
            Get Started
          </Button>
          <Button
            variant="outline"
            size="xl"
            iconName="Play"
            iconPosition="left"
            onClick={() => window.open('https://youtu.be/NmTYUuGiI3U', '_blank')}
            className="min-w-[200px]">
            Watch Demo
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-300">
            <div className="w-12 h-12 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="TrendingDown" size={24} color="var(--color-success)" strokeWidth={2.5} />
            </div>
            <h3 className="text-3xl font-bold text-success mb-2">-67%</h3>
            <p className="text-muted-foreground">Employee Churn Reduction</p>
          </div>

          <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-300">
            <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Zap" size={24} color="var(--color-primary)" strokeWidth={2.5} />
            </div>
            <h3 className="text-3xl font-bold text-primary mb-2">3x</h3>
            <p className="text-muted-foreground">Faster Productivity Ramp</p>
          </div>

          <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-300">
            <div className="w-12 h-12 bg-accent/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Euro" size={24} color="var(--color-accent)" strokeWidth={2.5} />
            </div>
            <h3 className="text-3xl font-bold text-accent mb-2">€77k</h3>
            <p className="text-muted-foreground">Annual Cost Savings</p>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;